<template>
    <div>
        <div class="row mt-3">
            <div class="col-md-12">
                <h1>Invoices</h1>
            </div>
        </div>
        <form v-on:submit.prevent="recordInvoice">
            <div class="row mt-1">
                <div class="col-md-12">
                    <div class="box">
                        <div class="form">
                            <div class="row form-wrap">
                                <div class="col-md-4">
                                    <label for="group_supplier">Currency Type</label>
                                    <v-select
                                        id="currency_type"
                                        :options="currencyTypes"
                                        placeholder="Select Currency Type"
                                        v-model="supplierInvoice.currency_type"
                                        required
                                    />
                                    <small class="text-danger"></small>
                                </div>
                                <div class="col-md-4">
                                    <label for="exchange_rate"> Exchange rate </label>
                                    <input id="exchange_rate" type="text" placeholder="Exchange rate" v-model="supplierInvoice.currency_exchange_rate">
                                    <small class="text-primary" v-if="supplierInvoice.currency_type && supplierInvoice.currency_exchange_rate"> 1 {{ supplierInvoice.currency_type }} = {{ supplierInvoice.currency_exchange_rate }} Sterling</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-wrap">
                                        <div>
                                            <label for="invoice_number">Invoice Number </label>
                                            <input id="invoice_number" type="text" placeholder="Invoice Number"  v-model="supplierInvoice.invoice_number">
                                        </div>
                                        <div>
                                            <label for="payment_date">Invoice date</label>
                                            <input id="payment_date" type="date" placeholder="Due date" v-model="supplierInvoice.invoice_date">
                                        </div>
                                        <div>
                                            <label for="invoice_amount">Invoice Total Amount</label>
                                            <input id="invoice_amount" 
                                                    type="number" 
                                                    placeholder="Invoice Amount" 
                                                    step="0.01"
                                                    v-model="supplierInvoice.invoice_amount">
                                        </div>
                                        <div>
                                            <label for="payment_date">Due date</label>
                                            <input id="payment_date" type="date" placeholder="Due date" v-model="supplierInvoice.invoice_due_date">
                                        </div>
                                        <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(40% - 1rem);">
                                            <label>Invoice PDF</label>
                                            <input id="file-upload" type="file" class="form-control" @change="uploadDoc" accept=".pdf">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-wrap">
                                        <div class="form-submit-inline">
                                        <button type="submit" class="button">
                                            <span> {{(supplierInvoice.flag =='add' ? 'Add' : 'Update')}} Invoice </span>
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <hr>
        <div class="row box pt-3">
            <div class="col-md-12">
                <div class="row p-3">
                    <div class="col-md-12" style="display: flex; justify-content: flex-end;">
                        <button class="btn btn-danger" @click="resetInvoices">
                            <i class="icon icon--reload"></i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <vdtnet-table
                            ref="table"
                            :fields="fields"
                            :opts="options"
                            :key="tableKey"
                            @ViewInvoice="ViewInvoice"
                            @editInvoice="editInvoice"
                            @editTableInvoice="editTableInvoice"
                            @deleteTableInvoice="deleteTableInvoice"
                            @capturePayment="capturePayment"
                            @linkTour="linkTour"
                            >
                            <template slot="paid_status" slot-scope="{ row }">
                                <template v-if="row.internal_payments.length > 0">
                                    <ul>
                                        <li v-for="internal_payment in row.internal_payments" :key="internal_payment.tour_group_payment_id">
                                            <a :href="`/tours/groups/${internal_payment.tour_group_id}`" class="text-danger">
                                                {{ internal_payment.tour_ref_name }} 
                                                ({{ Number(internal_payment.invoice_amount/row.currency_exchange_rate) | formatCurrency}})
                                            </a>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    N/A
                                </template>
                            </template>
                        </vdtnet-table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" v-if="showPaymentModal == true">
            <RecordPaymentModal :paymentfor="invoiceForTag" 
                                :paymentForObject="invoiceFor"
                                :paymentforid="invoiceFor.id" 
                                :selectedInvoice="selectedInvoice"
                                :recordedPayments="selected_invoice_payments"
                                @syncPayments="syncPayments"/>
            <button type="button" class="icon icon--unlink" v-on:click="showPaymentModal = false">Close</button>
        </div>

        <div class="modal__bg" v-if="showTourLinkModal == true"></div>
            <div class="modal" v-if="showTourLinkModal == true">
                <InvoiceTourLinkModal :paymentfor="invoiceForTag" 
                                    :paymentForObject="invoiceFor" 
                                    :selectedInvoice="selectedTourLinkInvoice"
                                    :invoiceFor="invoiceFor"
                                    :invoiceForTag="invoiceForTag" 
                                    :recordedPayments="selected_invoice_payments"
                                    @syncInvoices="syncInvoices"/>
                <button type="button" class="icon icon--unlink" v-on:click="showTourLinkModal = false">Close</button>
            </div>
        <div class="modal__bg" v-if="showTourLinkModal == true"></div>
    </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import RecordPaymentModal from '@/components/RecordPaymentModal.vue'
import InvoiceTourLinkModal from '@/components/InvoiceTourLinkModal.vue'

export default {
    name: 'InvoiceWithDetails',
    props: {
        invoices:Array,
        invoiceFor:Object,
        invoiceForTag:String
    },
    components: {
        RecordPaymentModal,
        InvoiceTourLinkModal,
        VdtnetTable  
    },
    mounted() {
        if ('downloadInvoice' in this.$route.query) {
            this.downloadInvoice(this.$route.query.downloadInvoice)
        }

        if ('invoice_id' in this.$route.query) {
            this.editInvoice(this.$route.query.invoice_id)
        }

        setTimeout(() => {
            if ('handlePayment' in this.$route.query) {
                this.recordPaymentModal(this.$route.query.handlePayment)
            }
            this.setDataTableValues()
            
        }, 1000);
    },
    data() {
        return {
            options: {},
            fields: {},
            tableKey:0,
            currencyTypes: ['USD', 'Sterling','EUR'],
            supplierInvoice: {
                flag: 'add',
                currency_type: 'Sterling',
                currency_exchange_rate: 1,
                invoice_number:null,
                invoice_amount: null,
                invoice_due_date: null,
                invoice_date: null,
                payment_invoice_file:null,
            },
            showPaymentModal: false,
            selectedInvoice: null,
            selected_invoice_payments: [],
            showTourLinkModal: false,
            selectedTourLinkInvoice: null,
        }
    },
    methods: {
        setDataTableValues() {
            this. options = {
                ajax: {
                    url: this.$api + 'invoices-table',
                    method: 'POST',
                    data: {
                        invoice_for: this.invoiceForTag,
                        invoice_for_id:this.invoiceFor.id,
                        selected_invoice_id: this.supplierInvoice ? this.supplierInvoice.supplier_invoice_id : null,
                    },
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                order: [[4, 'desc']],
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: true,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [10, 20, 40, 80, 100, 500], [10, 20, 40, 80, 100, 500] ],
                pageLength: 10,
                createdRow: (row, data) => {
                   $(row).addClass(`invoice-row-${ data.id}`);
                },
                drawCallback: (settings) => {
                    // Re-apply highlighting after table redraw
                    if (this.supplierInvoice.supplier_invoice_id) {
                        $(`.invoice-row-${this.supplierInvoice.supplier_invoice_id}`).addClass('highlighted-row');
                    }
                },
            }
            this.fields = {
                invoice_number: {
                    label: 'Invoice Number'
                },
                currency_type: {
                    label: 'Invoice Currency',
                    render: (data, type, row) => {
                        return `<ul>
                                    <li>Currency: <b>${ row.currency_type }</b></li>
                                    <li>Exchange: <b>${ row.currency_exchange_rate }(£)</b></li>
                                </ul>`
                    }
                },
                invoice_amount: {
                    label: 'Invoice Amount',
                    render: (data, type, row) => {
                        return `<ul>
                                    <li>Original: ${ this.$options.filters.CurrencySymbol(row.currency_type)}${ row.invoice_amount }</li>
                                    <li>Converted: ${ this.$options.filters.formatCurrency(Number(row.invoice_amount/row.currency_exchange_rate) )}</li>
                                </ul>`
                    }
                },
                payment_invoice_name: {
                    label: 'Invoice',
                    render: (data, type, row) => {
                        if (data) {
                            return `<a href="javascript:void(0)" class="color-orange" data-action="ViewInvoice">${ row.payment_invoice_name }</a>`
                        } else {
                            return '--'
                        }
                    }
                },
                invoice_date: {
                    label: 'Invoice Date',
                    render: (data, type, row) => {
                        return `${ (data) ? this.$options.filters.formatDate(data) : '--'}`
                    }
                },
                payment_due_date: {
                    label: 'Due Date',
                    render: (data, type, row) => {
                        return `${ this.$options.filters.formatDate(data)}`
                    }
                },
                paid_status: {
                    label: 'Invoice Use',
                    field: 'paid_status'
                },
                total_paid: {
                    label: 'Paid',
                    render: (data, type, row) => {
                        return `${ this.$options.filters.CurrencySymbol(row.currency_type)}${ Number(row.total_paid) }`
                    }
                },
                payment_invoice_path: {
                    label: 'Outstanding',
                    render: (data, type, row) => {
                       return `${ this.$options.filters.CurrencySymbol(row.currency_type)}${ Number(row.invoice_amount - row.total_paid) }`
                    }
                },
                tour_manager_id: {
                    label: ' ',
                    render: (data, type, row) => {
                       return `<a class="icon icon--more" data-action="editTableInvoice">Edit</a>`
                    }
                },
                affiliate_id: {
                    label: ' ',
                    render: (data, type, row) => {
                       return `<a class="icon icon--delete" data-action="deleteTableInvoice">Delete</a>`
                    }
                },
                currency_exchange_rate: {
                    label: ' ',
                    render: (data, type, row) => {
                        return `<button class="button" data-action="capturePayment"> <span> Payment </span> </button> <br>
                        <br><button class="button btn-warning p-2" data-action="linkTour"> <span> Link Tour </span> </button> <br>`
                    }
                },
            }
            this.tableKey++
        },
        uploadDoc(event){
            this.supplierInvoice.payment_invoice_file = event.target.files[0];
        },
        recordInvoice() {
        
            let This = this

            This.$store.dispatch('setLoadStatus')

            let formData = new FormData();

            if (This.invoiceForTag =='supplier') {
                This.supplierInvoice.supplier_id = This.invoiceFor.id
            } else if (This.invoiceForTag =='tour_manager') {
                This.supplierInvoice.tour_manager_id = This.invoiceFor.id
            }else if (This.invoiceForTag =='affiliate') {
                This.supplierInvoice.affiliate_id = This.invoiceFor.id
            }
            
            // Iterate through the object
            for (const key in This.supplierInvoice) {
                // Check if the property belongs to the object (not inherited)
                if (This.supplierInvoice.hasOwnProperty(key) && This.supplierInvoice[key]) {
                    // Append key-value pair to the FormData object
                    formData.append(key, This.supplierInvoice[key]);
                }
            }

            formData.append('invoice_for', This.invoiceForTag);
            
            fetch(`${This.$api}suppliers/${This.invoiceFor.id}/handle-invoices`, {
                method: 'POST',
                body: formData,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                This.errors = response.errors
                if(response.status) {
                    This.$notify({
                        type: 'success',
                        title: response.message
                    });
                    This.supplierInvoice = {
                        flag:'add',
                        currency_type: 'Sterling',
                        currency_exchange_rate: 1,
                    }
                    // This.$emit('handle-new-invoice', response.invoices_added)
                    This.setDataTableValues()
                } else if (response.errors) {
                    This.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                This.$store.dispatch('setLoadStatus')
            });

        },
        editTableInvoice({id }) {
            this.editInvoice(id)
        },
        editInvoice(invoice_id){
            let foundInvoice = this.invoices.find(element => element.id == invoice_id)
            
            if (foundInvoice) {
                this.supplierInvoice = {}
                this.supplierInvoice = {
                    flag: 'edit',
                    supplier_invoice_id:foundInvoice.id,
                    currency_type:  foundInvoice.currency_type,
                    currency_exchange_rate:  foundInvoice.currency_exchange_rate,
                    invoice_number: foundInvoice.invoice_number,
                    invoice_amount:  foundInvoice.invoice_amount,
                    invoice_due_date: foundInvoice.payment_due_date,
                    invoice_date: foundInvoice.invoice_date,
                }
                this.setDataTableValues()
            }
        },
        deleteTableInvoice({ id }) {
            this.deleteInvoice(id)
        },  
        deleteInvoice (invoice_id) {
            this.$dialog
            .confirm(`Are you sure you want to delete payment ?`)
            .then(() => {
                this.$store.dispatch('setLoadStatus')
                fetch(`${this.$api}suppliers/${this.invoiceFor.id}/delete-invoice/${invoice_id}`, {
                    method: 'POST',
                    body: JSON.stringify({
                        'invoice_for': this.invoiceForTag
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => res.json())
                .then(response => {
                    this.errors = response.errors
                    if(response.status) {
                        this.$notify({
                        type: 'success',
                        title: response.message
                        });
                        this.$emit('handle-new-invoice', response.invoices_added)
                    } else if (response.errors) {
                        this.$notify({
                        type: 'error',
                        title: response.message
                        });
                    } else {
                        this.$notify({
                        type: 'error',
                        title: response.Error
                        });
                    }
                    this.$store.dispatch('setLoadStatus')
                });
            }).catch((error) => {
                console.log(error);
                // this.$store.dispatch('setLoadStatus')
                console.log('Clicked on cancel');
            });
        },
        capturePayment({ id }) {
            this.recordPaymentModal(id)
        },
        recordPaymentModal(invoice_id) {
            let self = this
            self.$store.dispatch('setLoadStatus')
            fetch(`${self.$api}invoice/get-invoice-payments`, {
                method: 'POST',
                body: JSON.stringify({
                    'payment_for' : this.invoiceForTag,
                    'payment_for_id' : this.invoiceFor.id,
                    'invoice_id' : invoice_id
                }),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                self.errors = response.errors
                if (response.status) {
                    this.selectedInvoice = response.selected_invoice
                    this.selected_invoice_payments = response.recorded_payments;        
                    this.showPaymentModal = true

                } else if (response.errors) {
                    
                }
                self.$store.dispatch('setLoadStatus')
            });
        },
        syncPayments(paymentObject) {
            this.selected_invoice_payments = paymentObject;
        },
        ViewInvoice({ id, payment_invoice_name}) {
            this.downloadInvoice(id,payment_invoice_name)
        },
        downloadInvoice(payment_id, invoice_name=null) {
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}suppliers/download-internal-payment-invocie/${payment_id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then((res) => {
            if(res.status === 200) {
                this.$store.dispatch('setLoadStatus')
                res.blob().then(response => {
                    const _url = window.URL.createObjectURL(response)
                    const link = document.createElement('a')
                    link.href = _url
                    if (invoice_name) {
                        link.setAttribute('download', invoice_name)
                    } else {
                        link.setAttribute('download', 'Payment-Invoice.pdf')
                    }
                    document.body.appendChild(link)
                    link.click();
                })
            } else {
                this.$store.dispatch('setLoadStatus')
                Promise.race([res.json()])
                .then(response => {
                if(response.message) {
                    this.$notify({
                    type: 'error',
                    title: response.message
                    });
                } else {
                    this.$notify({
                    type: 'error',
                    title: response.error
                    });
                }
                })
            }
            });
        },
        linkTour(data) {
            this.showTourPickModal(data)
        },
        showTourPickModal(invoice) {
            this.selectedTourLinkInvoice = invoice
            this.showTourLinkModal = true
        },
        syncInvoices() {
            this.selectedTourLinkInvoice = null
            this.showTourLinkModal = false
            this.getSupplierInvoices()
        },
        getSupplierInvoices() {
            fetch(`${this.$api}suppliers/invoice/get-supplier-invoices`, {
                method: 'POST',
                body: JSON.stringify({
                    invoice_for:this.invoiceForTag,
                    invoice_for_id:this.invoiceFor.id
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if (response.status) {
                    this.$emit('handle-new-invoice', response.data)
                }
            });
        },
        resetInvoices() {

            this.supplierInvoice = {
                flag: 'add',
                currency_type: 'Sterling',
                currency_exchange_rate: 1,
                invoice_number:null,
                invoice_amount: null,
                invoice_due_date: null,
                invoice_date: null,
                payment_invoice_file:null,
            }
            this.setDataTableValues()
            this.clearQueryParameters()
        },
        clearQueryParameters() {
            // Remove all query parameters from the current route
            this.$router.replace({ 
                name: this.$route.name, 
                params: this.$route.params 
            })
        }
    }
}
</script>

<style scoped>
::v-deep .highlighted-row {
  background-color: #4477fb63 !important;
  border-left: 4px solid #ec391e !important;
  --bs-table-accent-bg: #ffe8a1 !important;
}

::v-deep .highlighted-row:hover {
  background-color: #4477fb63 !important;
}

</style>